<template>
  <div>
    <top-header-info></top-header-info>
    <top-logo state="1"></top-logo>
    <right-nav></right-nav>
    <home-nav></home-nav>
    <div class="block">
      <el-carousel height="454px">
        <el-carousel-item
          v-for="(item,index) in banners"
          :key="index"
          @click.native="goUrl(item.url)"
        >
          <div id="pic" :style="{'backgroundImage':`url(${item.image})`}"></div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div>
      <div class="w">
        <div class="filter">
          <div class="item">
            所在城市：
            <el-select v-model="city" filterable placeholder="请选择" @change="setCity">
              <el-option
                v-for="item in cities"
                :key="item.id"
                :label="item.city_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="item date-wrap">
            日期：
            <el-select v-model="date" placeholder="请选择日期" @change="getList">
              <el-option
                v-for="item in dateList"
                :key="item.id"
                :label="item.value"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="item sport-wrap">
            项目：
            <el-select v-model="sport" placeholder="请选择运动项目" @change="getList">
              <el-option
                v-for="item in sports"
                :key="item.id"
                :label="item.cat_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="mysearch-wrap">
            <el-input
              placeholder="(关键词选填)场馆名/位置/运动项目"
              v-model="minKeyword"
              @keyup.enter.native="getList"
            ></el-input>
          </div>
        </div>
        <is-empty v-if="isEmpty"></is-empty>
        <el-row class="court-list" v-else>
          <el-col :span="12" v-for="item in courtList" :key="item.id">
            <el-row>
              <el-col :span="9">
                <img
                  :src="item.image?venues_img_url:defaultGoods"
                  alt="sbz"
                  @click="goDetail(item.venues_id)"
                >
              </el-col>
              <el-col :span="12" class="text-info" @click.native="goDetail(item.venues_id)">
                <h3>{{item.venues_name}}</h3>
                <el-rate
                  v-model="item.comment_avg"
                  disabled
                  disabled-void-color="#ddd"
                  :colors="colors"
                ></el-rate>
                <div class="price-wrap">
                  上班族价：
                  <i class="price-text">{{item.venues_average_price |yuan}}</i>
                </div>
                <div class="address">场馆地址：{{item.venues_address}}</div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-pagination
          v-if="!isEmpty"
          background
          layout="prev, pager, next"
          :total="totalCourts"
          @current-change="changePage"
        ></el-pagination>
      </div>
    </div>
    <bottom-content></bottom-content>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
import HomeBanner from "@/components/home-banner";
import DEFAULTGOODS from "@/assets/images/goods_default.jpg";
import IsEmpty from "@/components/is-empty";

import {
  getCurrentDate,
  getWhenDate,
  dayFormat
} from "@/assets/js/timeFormat.js";

export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav,
    IsEmpty
  },
  data() {
    return {
      curCategories: [],
      curCategoryType: "",
      defaultGoods: DEFAULTGOODS,
      banners: [
        { image: "http://pic1.win4000.com/wallpaper/a/5806d6bbe0dd6.jpg" }
      ],
      city: "",
      cities: [],
      date: "",
      dateList: [],
      sport: "",
      sports: "",
      minKeyword: "",
      courtList: [],
      page: 1,
      colors: ["#FD6C17", "#FD6C17", "#FD6C17"],
      totalCourts: 0,
      isEmpty: false
    };
  },
  watch: {
    $route: {
      handler() {
        this.getData();
        this.category.map(item => {
          if (item.type == this.$route.query.type) {
            // this.curCategories = item.categories;
            this.curCategoryType = item.type;
          }
        });
      }
    }
  },
  mounted() {
    this.category = JSON.parse(
      this.$util.getSessionStorage("category").category
    );
    this.category.map(item => {
      if (item.type == this.$route.query.type) {
        this.curCategoryType = item.type;
      }
    });
    // this.$reqGet("api/store/quyundong/sync_region").then(res => {
       this.getCities();
      this.getDateList();
      this.getSports();
    // });
  },
  methods: {
    getList() {
      let obj = {
        city_id: this.city || 0,
        cat_id: this.sport || 0,
        date: this.date,
        page: this.page,
        hour: 0,
        limit:10
      };

      if (this.minKeyword) {
        obj.keyword = this.minKeyword;
      }
      this.$reqGet("api/store/quyundong", obj).then(res => {
        this.courtList = res.data.data.data;
        if (this.courtList.length == 0) {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }
        this.totalCourts = res.data.data.total;
      });
    },
    getCities() {
      this.$reqGet("api/store/quyundong/city").then(res => {
        this.cities = res.data.data;
        if (this.cities.length > 0) {
          this.city = this.cities[0].id;
          if (this.sport) {
            this.getList();
          }
          if (localStorage.getItem("myCity")) {
            this.city = JSON.parse(localStorage.getItem("myCity")).id;
          }
        }
      });
    },
    getDateList() {
      let startDate = getCurrentDate(1);
      let startDate_ms = Date.parse(new Date(startDate.replace(/-/g, "/")));
      const DAYS = 7;
      let next = "";
      for (let i = 0; i < DAYS; i++) {
        next = getWhenDate(startDate_ms, i);
        this.dateList.push({
          value: next,
          id: getWhenDate(startDate_ms, i, 1)
        });
        // this.myDateList.push(getWhenDate(startDate_ms, i, 1));
      }
      this.date = this.dateList[0].id;
    },
    getSports() {
      this.$reqGet("api/store/quyundong/category").then(res => {
        this.sports = res.data.data;
        sessionStorage.setItem("sportsCate", JSON.stringify(this.sports));
        if (this.sports.length > 1) {
          this.sport = this.sports[0].id;
          if (this.city) {
            this.getList();
          }
        }
      });
    },
    changePage(val) {
      this.page = val;
      this.getList();
    },
    setCity(val) {
      this.cities.map(item => {
        if (item.id == val) {
          localStorage.setItem("myCity", JSON.stringify(item));
        }
      });
      this.getList();
    },
    goDetail(id) {
      let routeUrl = this.$router.resolve({
        name: "qyd-detail",
        query: { veneus_id: id, cate_id: this.sport }
      });
      window.open(routeUrl.href, "_blank");
    },

    goToTop() {
      window.scrollTo(0, 0);
      this.setNotChecked();
    }
  }
};
</script>

<style lang="less" scoped>
#pic {
  width: 100%;
  height: 454px;
  background-size: cover;
  background-position: center;
}
.el-carousel /deep/ .el-icon-arrow-left::before {
  content: "\E600" !important;
}
.el-carousel /deep/ .el-icon-arrow-right::before {
  content: "\E604" !important;
}
.w {
  margin-top: 30px;
}
.filter {
  display: flex;
  padding: 10px 15px;
  background-color: #ebebeb;
  color: #999;
  > div {
    flex: 1;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    margin-right: 15px;
    padding-left: 10px;
  }
}
.filter /deep/ .el-input__inner {
  border: none;
}
.date-wrap /deep/ .el-input__suffix ,.sport-wrap /deep/ .el-input__suffix{
  right: -15px;
  top: 9px;
}
.date-wrap /deep/ .el-input__suffix-inner > i ,.sport-wrap /deep/ .el-input__suffix-inner > i {
  display: none;
}
.date-wrap /deep/ .el-input__suffix-inner::after {
  content: url(../../assets/images/date.png);
}
.sport-wrap /deep/ .el-input__suffix-inner::after {
  content: url(../../assets/images/exercise.png);
}
.court-list {
  padding: 15px;
  background-color: #fff;
  min-height: 300px;
  > .el-col {
    padding: 15px;
    img {
      width: 180px;
      height: 140px;
      border-radius: 5px;
      cursor: pointer;
    }
    .text-info {
      cursor: pointer;
      font-size: 18px;
      color: #666;
      h3 {
        height: 28px;
        font-size: 20px;
        color: #222;
        margin: 0;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
      }
      .el-rate {
        height: 44px;
        line-height: 52px;
      }
      .price-wrap {
        line-height: 36px;
        .price-text {
          color: #4b70cc;
          font-size: 22px;
        }
      }
      .address {
        height: 28px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        line-height: 36px;
      }
    }
  }
}
.court-list /deep/ .el-rate__icon {
  font-size: 22px;
  margin-right: 3px;
}
.el-pagination {
  text-align: right;
  background-color: #fff;
  padding: 0 20px 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/category/qyd-home.vue